import * as Yup from "yup";
import { DELIVERY_TYPES } from "constants";

export const doSchema = Yup.object().shape({
  pickUpSlotFrom: Yup.date().when("deliveryType", {
    is: DELIVERY_TYPES?.jots,
    then: Yup.date()
      .required("Please enter Pick-up slot: From field")
      .min(
        new Date(),
        "Pick-up From time must be current date & time or later",
      ),
    otherwise: Yup.date().notRequired(),
  }),

  pickUpSlotTo: Yup.date().when(["deliveryType", "pickUpSlotFrom"], {
    is: (deliveryType) => deliveryType === DELIVERY_TYPES?.jots,
    then: Yup.date()
      .required("Please enter Pick-up slot: To field")
      .min(
        Yup.ref("pickUpSlotFrom"),
        "Pick-up To time must be equal or after From time",
      ),
    otherwise: Yup.date().notRequired(),
  }),

  sellerAddress: Yup.string().when("deliveryType", {
    is: (deliveryType) =>
      deliveryType === DELIVERY_TYPES?.jots ||
      deliveryType === DELIVERY_TYPES?.sellerDelivery,
    then: Yup.string().required("Seller address is required"),
    otherwise: Yup.string().notRequired(),
  }),
});
